import { formatAnalysisValue } from "../../formatters"
import { FieldViewModel, isNumber, ISoilAnalysis, SoilAnalysisType } from "../../omnia"
import { IAnalysisValueColumn, IDataLayer, IDataLayerZone, ISoilService } from "../../types"
import { AnalysisVM, createFieldAnalysis, createZoneAnalysis } from "../analysis-vm"

/// <reference path="../analysis-vm.ts" />

export class SoilAnalysisVM extends AnalysisVM<ISoilAnalysis> {

    public static create(svc: ISoilService, type: SoilAnalysisType, layers: IDataLayer[], field: FieldViewModel, selectedZoneId: number, currentView: boolean) {

        const analysis = svc.getSoilAnalyses(type)

        let fields = createFieldAnalysis(
            analysis,
            field,
            a => new SoilAnalysisVM(a),
            selectedZoneId,
            currentView);

        let zones = createZoneAnalysis(
            analysis,
            field,
            svc.yearId,
            layers,
            (analysis, layer, zone) => new SoilAnalysisVM(analysis, layer, zone),
            selectedZoneId,
            currentView);

        return fields.concat(zones);

    }

    constructor(analysis: ISoilAnalysis, layer?: IDataLayer, zone?: IDataLayerZone) {
        super(analysis, layer, zone);
    }

    getAnalysisValue(column: IAnalysisValueColumn) {
        return formatAnalysisValue(this.analysis, column)
    }

    hasAnalysisValue(column: IAnalysisValueColumn): boolean {
        return isNumber(this.analysis[column.name]);
    }

}
